import React, { useState, useEffect, useRef } from 'react';
import logoIcon from './assets/icon.png';

const Videos = () => {
  const [activeVideo, setActiveVideo] = useState(0);
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);

  // Intersection Observer to detect when section is in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      {
        threshold: 0.3, // Trigger when 30% of the section is visible
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const videos = [
    {
      id: 1,
      title: 'Masth Kalandar Official Trailer',
      thumbnail: 'https://img.youtube.com/vi/qibh7pGWWp4/maxresdefault.jpg',
      videoId: 'qibh7pGWWp4',
      category: 'Trailer'
    },
    {
      id: 2,
      title: 'A!!! Movie Promo',
      thumbnail: 'https://img.youtube.com/vi/ApHroUixRQ8/maxresdefault.jpg',
      videoId: 'ApHroUixRQ8',
      category: 'Promo'
    },
    {
      id: 3,
      title: 'Behind The Scenes',
      thumbnail: 'https://img.youtube.com/vi/Rpqwmriy640/maxresdefault.jpg',
      videoId: 'Rpqwmriy640',
      category: 'BTS'
    }
  ];

  return (
    <section id="videos" className="videos-section" ref={sectionRef}>
      <div className="container">
        {/* Title */}
        <div className="text-center mb-8">
          <h2 className="section-title" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0' }}>
            <img src={logoIcon} alt="O" style={{ width: '3rem', height: '3rem', objectFit: 'contain', marginRight: '-0.2rem', border: '2px solid #B8860B', borderRadius: '50%', padding: '2px' }} />ur Vide
            <img src={logoIcon} alt="o" style={{ width: '2.8rem', height: '2.8rem', objectFit: 'contain', margin: '0 -0.1rem', border: '2px solid #B8860B', borderRadius: '50%', padding: '2px' }} />s
          </h2>
          <p className="section-subtitle">Experience our cinematic journey</p>
        </div>

        {/* Main Video Player */}
        <div className="main-video-player">
          <div className="video-frame">
            <iframe
              src={`https://www.youtube.com/embed/${videos[activeVideo].videoId}?${isInView ? 'autoplay=1' : 'autoplay=0'}&rel=0`}
              title={videos[activeVideo].title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="video-info">
            <span className="video-category">{videos[activeVideo].category}</span>
            <h3>{videos[activeVideo].title}</h3>
          </div>
        </div>

        {/* Video Thumbnails Scroll */}
        <div className="video-thumbnails-container">
          <div className="video-thumbnails">
            {videos.map((video, index) => (
              <div
                key={video.id}
                className={`video-thumbnail ${index === activeVideo ? 'active' : ''}`}
                onClick={() => setActiveVideo(index)}
              >
                <div className="thumbnail-image">
                  <img src={video.thumbnail} alt={video.title} />
                  <div className="thumbnail-overlay">
                    <div className="play-icon">▶</div>
                  </div>
                  {index === activeVideo && (
                    <div className="now-playing">NOW PLAYING</div>
                  )}
                </div>
                <div className="thumbnail-info">
                  <span className="thumbnail-category">{video.category}</span>
                  <p>{video.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Videos;
